import { fetchJackpotsV2 } from '../../model/jackpotsV2';
import { JackpotsV2ResponseType } from '../../types/jackpotTypes';

export const getJackpotsForJPTiles = async (
  groupedJPCodesEntries: [string, string[]][],
  currency?: string
) => {
  const JPPromises = groupedJPCodesEntries.map(
    ([provider, gamesJackpotCodes]) =>
      fetchJackpotsV2({
        gamesJackpotCodes,
        provider,
        currency,
      })
        .then(jackpots => [provider, jackpots] as const)
        .catch(() => [])
  );
  const response = await Promise.all(JPPromises);
  return response.reduce(
    (jackpots, [provider, jpResponse]) => ({
      ...jackpots,
      [provider]: setCurrentTimestamp(jpResponse),
    }),
    {} as Record<string, JackpotsV2ResponseType>
  );
};

const setCurrentTimestamp = (jpResponse: JackpotsV2ResponseType) =>
  Object.fromEntries(
    Object.entries(jpResponse).map(([key, value]) => [
      key,
      { ...value, timestamp: new Date().toISOString() },
    ])
  );
